var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "45.000000pt",
    height: "44.000000pt",
    viewBox: "0 0 45.000000 44.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,44.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90 350 l0 -80 -28 0 c-45 0 -52 -16 -52 -110 0 -94 7 -110 52 -110 21 0 28 -5 28 -20 0 -19 7 -20 135 -20 128 0 135 1 135 20 0 15 7 20 29 20 44 0 61 31 61 110 0 79 -17 110 -61 110 -25 0 -29 4 -29 26 0 16 -17 46 -46 80 l-46 54 -89 0 -89 0 0 -80z m160 10 l0 -50 45 0 c38 0 45 -3 45 -20 0 -19 -7 -20 -115 -20 l-115 0 0 70 0 70 70 0 70 0 0 -50z m48 0 l23 -30 -26 0 c-21 0 -25 5 -25 30 0 17 1 30 3 30 2 0 13 -13 25 -30z m117 -200 l0 -85 -27 -3 c-24 -3 -28 0 -28 22 0 16 6 26 15 26 8 0 15 5 15 10 0 6 -62 10 -165 10 -103 0 -165 -4 -165 -10 0 -5 7 -10 15 -10 9 0 15 -10 15 -26 0 -22 -4 -25 -27 -22 -27 3 -28 5 -31 77 -2 41 -1 80 2 88 5 11 42 13 193 11 l188 -3 0 -85z m-75 -85 l0 -45 -115 0 -115 0 0 45 0 45 115 0 115 0 0 -45z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.35e8c5156304dc2bd4426eb2f47aceaf.svg";
export { ForwardRef as ReactComponent };